export const DEMO_SCRAPE_URL = 'https://n8n.hireportal.ai/webhook/demo-scraping';

export const startDemoScraping = async (candidateId) => {
  const response = await fetch(DEMO_SCRAPE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      candidate_id: candidateId,
    }),
  });

  const text = await response.text();
  let data = text;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    // Keep raw text if n8n returns a non-JSON body.
  }

  return {
    ok: response.ok,
    status: response.status,
    data,
  };
};
